<template>
    <div></div>
</template>

<script>

export default {
    name: 'telemetry-info-dialog'
}

</script>